export type IconType = keyof typeof iconsSrcMap
export const iconsSrcMap = {
  VEGAN: { name: "Vegan.svg" },
  "LACTOSE-FREE": { name: "MilkBottle1.svg" },
  VETERINARIAN: { name: "Pets.svg" },
  "GLUTEN-FREE": { name: "GenericPharma.svg" },
  "DERMATOLOGISTS-RECOMMENDATION": { name: "DermatologistRecommendation.png" }
}
